import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export default makeStyles({
  distribuicaoValores: {
    display: 'flex',
    gap: '8px',
    alignSelf: 'center',
  },
  filtroValorContainer: {
    display: 'flex',
    gap: '8px',
  },

  headerResumo: {
    textAlign: 'center',
  },

});

export const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const HeadContainer = styled.div`
    display: flex;
    align-content: space-between;
    flex: 1;
`;

export const ResumoRootContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    flex: 1;
    margin-left: 16px;
`;

export const ResumoSearchActionContainer = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;

export const ResumoOptionsContainer = styled.div`
    display: flex;
    gap: 8px;
`;

export const ValoresActionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ResumoContainer = styled.div` 
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TabelaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
